var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":require("../../../public/img/logo_entreprise.png"),"alt":"IDEAL SOLUTIONS"}})])])
}]

export { render, staticRenderFns }